module.exports = __webpack_public_path__ + "img/it-growth.ef65b7cb.jpg";